import type { Item } from '../order/order.interface';
import { ObjectFactory } from './object.factory';

export class ItemFactory extends ObjectFactory<Item> {
  protected getDefaults(): Item {
    return {
      label: 'Widget',
      quantity: 2,
    };
  }
}

export const itemFactory = new ItemFactory();
